import { render, staticRenderFns } from "./shared-notes.html?vue&type=template&id=7deb27c6&scoped=true&external"
import script from "./shared-notes.js?vue&type=script&lang=js&external"
export * from "./shared-notes.js?vue&type=script&lang=js&external"
import style0 from "./shared-notes.scss?vue&type=style&index=0&id=7deb27c6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb27c6",
  null
  
)

export default component.exports